import { Component, ElementRef, ViewChild } from '@angular/core';
import { ICellEditorAngularComp } from 'ag-grid-angular';
import { ICellEditorParams } from 'ag-grid-community';

@Component({
    selector: 'numeric-editor',
    template: `
        <app-mazars-input-number
            #input
            [showButtons]="false"
            [height]="42"
            [tooltipText]="tooltipText"
            [(ngModel)]="value"
            style="width: 100%;"
            [uid]="'numeric-editor-' + tooltipText"
        ></app-mazars-input-number>
    `,
})
export class NumericEditorComponent implements ICellEditorAngularComp {
    @ViewChild('input', {read: ElementRef}) input: ElementRef;
    public value!: number;
    public tooltipText: string;

    agInit(params: ICellEditorParams): void {
        this.value = params.value;
        this.tooltipText = params.data;
    }

    focusIn() {
        setTimeout(() => this.input.nativeElement.querySelector('input').focus());
    }

    getValue(): any {
        return this.value;
    }

    isCancelBeforeStart(): boolean {
        return false;
    }

    isCancelAfterEnd(): boolean {
        return false;
    }
}
